import { render, staticRenderFns } from "./EventsListPageSizeSelector.vue?vue&type=template&id=11b8a677"
import script from "./EventsListPageSizeSelector.vue?vue&type=script&lang=js"
export * from "./EventsListPageSizeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports